const bookingBaseUrl = import.meta.env.VITE_APP_BOOKING_BASE_URL?.trim()

export function getBookingUrl(bookingRef: string | undefined | null): string | null {
  const ref = bookingRef?.trim()
  if (!ref) return null
  if (!bookingBaseUrl) return null

  return `${bookingBaseUrl}/${encodeURIComponent(ref)}`
}
